import jwt_decode from 'jwt-decode'
import _ from 'lodash'

export const isTokenValid = (token: string): boolean => {
  const t: any = jwt_decode(token)
  return new Date(t.exp * 1000) > new Date()
}

export const getOty = (token: string): string => {
  try {
    const t: any = jwt_decode(token)
    return t.oty ? t.oty : ''
  } catch (error: any) {
    return ''
  }
}

export const getOid = (token: string): string => {
  try {
    const t: any = jwt_decode(token)
    return t.oid ? t.oid : ''
  } catch (error: any) {
    return ''
  }
}

export const getIsa = (token: string): string => {
  try {
    const t: any = jwt_decode(token)
    return t.isa ? t.isa : ''
  } catch (error: any) {
    return ''
  }
}

export const getFullName = (token: string): string => {
  try {
    const t: any = jwt_decode(token)
    return _.startCase(
      (t.fna && t.lna ? `${t.fna} ${t.lna}` : t.oty).toLowerCase()
    )
  } catch (error: any) {
    return ''
  }
}

export const getEmailAddress = (token: string): string => {
  try {
    const t: any = jwt_decode(token)
    return t.email ? t.email : ''
  } catch (error: any) {
    return ''
  }
}

export const isDemoOrgId = (token: string) =>
  getOid(token) === '51ae1b6a-a3c5-4fe0-88d5-cda5e2d7c8a2'
// export const isDemoOrgId = (token: string) => getOid(token) ==='15462ad7-d9f7-4867-a5c5-4b5a7f3fa382'
